import { useMutation, useQuery, useQueryClient } from '@zg-rentals/react-query5';
import { user } from '@/src/lib/api/endpoints/user';
import type { RenterProfileApiQuery } from '@/src/lib/api/endpoints/user';
import { transformRenterProfileFromApi } from '@/src/lib/utils/renterProfileTransforms';

import { renterProfileKeys } from './queryKeys';

export const useRenterProfile = () => {
  return useQuery({
    queryKey: renterProfileKeys.get(),
    queryFn: async () => {
      const response = await user.getRenterProfile();
      return transformRenterProfileFromApi(response.data);
    },
    staleTime: 60_000,
  });
};

export const useUpdateRenterProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RenterProfileApiQuery) => user.updateRenterProfile(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: renterProfileKeys.all });
    },
  });
};
